import { render, staticRenderFns } from "./addFormZhong.vue?vue&type=template&id=5e4c885c&scoped=true&"
import script from "./addFormZhong.vue?vue&type=script&lang=js&"
export * from "./addFormZhong.vue?vue&type=script&lang=js&"
import style0 from "./addFormZhong.vue?vue&type=style&index=0&id=5e4c885c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c885c",
  null
  
)

export default component.exports